import { StaticImage } from "gatsby-plugin-image";
import React from "react";

import { useTranslate } from "@hooks/useTranslate";

import * as Styled from "./Image.styled";

export const Image: React.FC<
  Pick<React.ComponentPropsWithoutRef<"div">, "className">
> = ({ className }) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  return (
    <Styled.Root className={className}>
      <StaticImage
        src={"./become_batmaid.webp"}
        alt={translate("become_a_batmaid_image_alt")}
        placeholder="blurred"
        layout="fullWidth"
        quality={100}
      />
    </Styled.Root>
  );
};
